module.exports = __webpack_public_path__ + "static/media/rpmGradient.b3993c96.svg";